import { toAbsoluteUrl } from "../toAbsoluteUrl";
import React, { useState, useEffect } from "react";
import { callApi } from "../API";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FileUpload from "./uploadFile.jsx";

import * as z from "zod";
import { borderRadius, height } from "@mui/system";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 570,
  bgcolor: "background.paper",
  padding: 3,
  borderRadius: "16px",
  background: "var(--Neutrals-White, #FFF)", // using CSS variable with fallback
  border: "unset",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  overflowY: 'auto',

  "@media (max-width: 767px)": {
    width: "100%", // Full width for screens smaller than 600px
    padding: "16px",
    height: "100%",
    borderRadius: "0",
  },
};
const emailSchema = z.string().email("Invalid email address");
export default function InvitePage(props) {
  const [emailError, setEmailError] = useState("");
  const [updateEmail, setUpdateEmail] = useState("");
  const [email, setEmail] = useState("");
  const [indexOfEdit, setIndexOfEdit] = useState(10000000);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileDone, setUploadedFileDone] = useState(false);
  const [sendInvite, setSendInvite] = useState("0");
  // typeOfInvite 0 for invite one by one
  // typeOfInvite 1 for bulk invite
  const [sendBulkInvite, setSendBulkInvite] = useState(false);  
  const [typeOfInvite, setTypeOfInvite] = useState("0");
  const [invitationList, setInvitationList] = useState([]);
  const [passedEmail, setPassedEmail] = useState([]);
  const [failedEmail, setFailedEmail] = useState([]);
  const [displayAlert, setDisplayAlert] = useState(true);
  const [showFormatError, setShowFormatError] = useState(false);
  const [updateEmailCheck, setUpdateEmailCheck] = useState(false);
  
  
  function backFunction(params) {
    setFailedEmail([]);
    setPassedEmail([]);
    setInvitationList([]);
    setUploadedFile(null);
    setSendInvite(0);
    setUploadedFileDone(false); 
    setShowFormatError(false);
    setIndexOfEdit(100000)
  }
  function returnPassedEmailBulk(params) {
    let emailList = "";
    emailList = passedEmail.map((rowData, index) => {
      return (
        <tr>
          <td className="col-md-10 col-12 order-2 ">
            <span className="d-block d-md-none">Work Email </span> {rowData}
          </td>
          <td className=" col-md-10 col-12 order-1 padding-td align-text-media">
            <img
              src={toAbsoluteUrl("/media/images/trash-2.svg")}
              alt="remove-icon"
              className="pointer notDark"
              onClick={() => removePassedEmailBulk(index)}
            />
            <img
              src={toAbsoluteUrl("/media/images/trash-2-dark.svg")}
              alt="remove-icon"
              className="pointer darkMode"
              onClick={() => removePassedEmailBulk(index)}
            />
          </td>
        </tr>
      );
    });
    return (
      <div className="w-100">
      <table>
        <thead>
          <tr className="d-none d-md-table-row">
            <th className="col-10">Work Email</th>
            <th className="col-2">Actions</th>
          </tr>
        </thead>
        <tbody>{emailList}</tbody>
      </table>
      <div className="count-of-record">
      <span>{passedEmail.length} Record</span>
    </div>
    </div>
    );
  }

  useEffect(() => {
    if (uploadedFileDone) {
      uploadData();
    }
  }, [uploadedFileDone]);
  const uploadData = async (params) => {
    let formData = new FormData();
    formData.append("file", uploadedFile);
    formData.append("type", "uploadTemplate");
    // formData.append("bussinessUserId", 2974);
    const domain = window.API_DASHBOARD_DATA;
    let response = await fetch(domain, { body: formData, method: "POST" });
    let res = await response.json();
    setInvitationList(res.emails);
  };
  function changeInviteBulk(params) {
    setTypeOfInvite(params);
  }
  function finishInviteOneByOne(params) {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "inviteAllV2",
      emailUser: passedEmail,
      // bussinessUserId: '2974',
    })
      .then((data) => {
        setSendInvite(1);
        props.closeModal();
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
 function updateFailedEmail (index) {
  let updatedEmails = [...failedEmail];
  if (updateEmail) {
    updatedEmails[index] = updateEmail;
  }
    checkEmailFormat([...passedEmail ,...updatedEmails])
   setUpdateEmailCheck(true)
  setIndexOfEdit(1000000)
 
}
  const handleChangeEmail = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    try {
      emailSchema.parse(newEmail);
      setEmailError(""); // Clear error if valid
    } catch (e) {
      setEmailError(e.errors[0].message); // Set error message if invalid
    }
  };
  function addEmailOneByOne(params) {
    if (email) {
      setInvitationList([...invitationList, email]);
      setEmail("");
    }
  }
  function removePassedEmailBulk(removeIndex) {
    setPassedEmail(
      passedEmail.filter((_, index) => index !== removeIndex)
    );
  }
  function removeEmailOneByOne(removeIndex) {
    setInvitationList(
      invitationList.filter((_, index) => index !== removeIndex)
    );
  }
  function removeEmailFailed(removeIndex) {
    setFailedEmail(failedEmail.filter((_, index) => index !== removeIndex));
  }
  function returnFailedEmail(params) {
    if (failedEmail.length > 0) {
      let failedEmailList = "";
      failedEmailList = failedEmail.map((rowData, index) => {
        return (
          <tr className="padding-of-tr failed-email">
            <td className="col-md-8 col-6">
              {" "}
              <span className="d-block d-md-none">Work Email </span> {rowData}
            </td>
            <td className="col-md-8 col-6">
              <span className="d-block d-md-none">Status</span>
              <p className="disabled-status">Failed</p>
            </td>
          </tr>
        );
      });
      return (
        <div className="w-100">
          <table>
            <thead>
              <tr className="d-none d-md-table-row">
                <th className="col-8">Work Email</th>
                <th className="col-4">Invitations Status</th>
              </tr>
            </thead>
            <tbody>{failedEmailList}</tbody>
          </table>
          <div className="count-of-record">
            <span>{failedEmail.length} Record</span>
          </div>
        </div>
      );
    }
  }
  function returnFailedEmailBulk(params) {
    if (failedEmail.length > 0) {
      let failedEmailList = "";
      failedEmailList = failedEmail.map((rowData, index) => {
        return (
          <tr className={`${indexOfEdit !== index && 'failed-email'}`}>
            <td className="col-md-10 col-12 order-2">
              {indexOfEdit == index ? (
                <input
                  className="W-100 input-border"
                  type="text"
                  defaultValue={rowData}
                  onChange={(e)=> setUpdateEmail(e.target.value)}
                />
              ) : (
                rowData
              )}
            </td>
            <td className="col-md-10 col-12 padding-td align-text-media order-1">
              {indexOfEdit != index ? (
                <div className="display-action-table">
                  <img
                    src={toAbsoluteUrl("/media/images/trash-2.svg")}
                    alt="remove-icon"
                    className="pointer notDark"
                    onClick={() => removeEmailFailed(index)}
                  />
                   <img
                    src={toAbsoluteUrl("/media/images/trash-2-dark.svg")}
                    alt="remove-icon"
                    className="pointer darkMode"
                    onClick={() => removeEmailFailed(index)}
                  />
                  <img
                    src={toAbsoluteUrl("/media/images/edit.svg")}
                    alt="remove-icon"
                    className="pointer"
                    onClick={() => setIndexOfEdit(index)}
                  />
                </div>
              ): <div className="d-flex justify-content-end">
              <img
                src={toAbsoluteUrl("/media/images/check.svg")}
                alt="remove-icon"
                className="pointer"
                onClick={() => updateFailedEmail(index)}
              />
            </div>}
            </td>
          </tr>
        );
      });
      return (
        <div className="w-100">
          <table>
            <thead>
              <tr className="d-none d-md-table-row">
                <th className="col-10">Work Email</th>
                <th className="col-2">Action</th>
              </tr>
            </thead>
            <tbody>{failedEmailList}</tbody>
          </table>
          <div className="count-of-record">
            <span>{failedEmail.length} Record</span>
          </div>
        </div>
      );
    }
  }
  function returnPassedEmail(params) {
    if (passedEmail.length > 0) {
      let passedEmailList = "";
      passedEmailList = passedEmail.map((rowData, index) => {
        return (
          <tr className="padding-of-tr">
            <td className="col-md-8 col-6">
              {" "}
              <span className="d-block d-md-none">Work Email </span> {rowData}
            </td>
            <td className="col-md-8 col-6">
              <span className="d-block d-md-none">Status</span>
              <p className="active-status">Successful</p>
            </td>
          </tr>
        );
      });
      return (
        <div className="w-100">
          <table>
            <thead>
              <tr className="d-none d-md-table-row">
                <th className="col-8">Work Email</th>
                <th className="col-4">Invitations Status</th>
              </tr>
            </thead>
            <tbody>{passedEmailList}</tbody>
          </table>
          <div className="count-of-record">
            <span>{passedEmail.length} Record</span>
          </div>
        </div>
      );
    }
  }
  function displayEmailOneByOne(params) {
    if (sendInvite == 0) {
      let emailList = "";
      emailList = invitationList.map((rowData, index) => {
        return (
          <tr>
            <td className="col-md-10 col-12 order-2 ">
              <span className="d-block d-md-none">Work Email </span> {rowData}
            </td>
            <td className=" col-md-10 col-12 order-1 padding-td align-text-media">
              <img
                src={toAbsoluteUrl("/media/images/trash-2.svg")}
                alt="remove-icon"
                className="pointer notDark"
                onClick={() => removeEmailOneByOne(index)}
              />
              <img
                src={toAbsoluteUrl("/media/images/trash-2-dark.svg")}
                alt="remove-icon"
                className="pointer darkMode"
                onClick={() => removeEmailOneByOne(index)}
              />
            </td>
          </tr>
        );
      });
      return (
        <table>
          <thead>
            <tr className="d-none d-md-table-row">
              <th className="col-10">Work Email</th>
              <th className="col-2">Actions</th>
            </tr>
          </thead>
          <tbody>{emailList}</tbody>
        </table>
      );
    } else{
      return (
        <div className="d-flex gap-18 align-items-start display-tables">
          {console.log('showFormatError',showFormatError)}
          
           {uploadedFileDone && showFormatError?
           <>
            {returnFailedEmailBulk()}
            {returnPassedEmailBulk()}
            </>:
          <>{returnFailedEmail()}
          {returnPassedEmail()}
          </>}
          
          
        </div>
      );
    }
  }
  //   d-flex gap-18 align-items-start
  function inviteOneByOne(params) {
    const domain = window.API_DASHBOARD_DATA;
    let newListOfUsers = []
    console.log('params---->',params);
    
    if (params) {
      newListOfUsers = params
    } else {
      uploadedFileDone ?newListOfUsers =passedEmail:newListOfUsers=invitationList;
    }
    
    
    console.log('newListOfUsers',newListOfUsers);
    
    callApi(domain, {
      type: "addInvitationV2",
      emailUser: newListOfUsers,
      // bussinessUserId: '2974',
    })
      .then((data) => {
        console.log('data',data.emails.passed);
        setSendInvite(1);
        data.emails.passed && setPassedEmail(data.emails.passed);
        data.emails.failed && setFailedEmail(data.emails.failed);
        setShowFormatError(false)
        setSendBulkInvite(true)
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  function displayHeaderOfModal(params) {
    if (params == 2) {
      return (
        <div className="d-flex justify-content-between header-of-modal ">
          <h2>Invited Employees List</h2>
          <img
            onClick={() => props.closeModal()}
            src="/businessDashboard/media/images/Close-x.svg"
            className="pointer close-image notDark"
          />
          <img
            onClick={() => props.closeModal()}
            src="/businessDashboard/media/images/Close-x-dark.svg"
            className="pointer close-image darkMode"
          />
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-between header-of-modal">
          <h2>Invite Employees</h2>
          <img
            onClick={() => props.closeModal()}
            src="/businessDashboard/media/images/Close-x.svg"
            className="pointer close-image notDark"
          />
          <img
            onClick={() => props.closeModal()}
            src="/businessDashboard/media/images/Close-x-dark.svg"
            className="pointer close-image darkMode"
          />
        </div>
      );
    }
  }
  function checkEmailFormat(params) {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "checkEmailsFormat",
      emailUser: params,
      // bussinessUserId: '2974',
    })
      .then((data) => {
        setSendInvite(1);
        
        if (data.emails.failed.length > 0) {
        data.emails.passed && setPassedEmail(data.emails.passed);
        data.emails.failed && setFailedEmail(data.emails.failed);
          setShowFormatError(true)
        }else{
            inviteOneByOne(data.emails.passed)
          setShowFormatError(false)
        }
        
        // data.emails.failed.length > 0 ? :
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  return (
    <Modal
      className="react-style"
      open={props.open}
      onClose={props.closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {/* <FileUpload /> */}
      {typeOfInvite == 0 ? (
        <Box sx={style}>
          {sendInvite == 0 && (
            <div className="display-items-on-modal">
              {displayHeaderOfModal(1)}
              <div className="d-flex gap-18 align-items-start">
                <div className="w-100">
                  <div class="inp w-100">
                    <input
                      class=" input w-100"
                      onChange={handleChangeEmail}
                      placeholder=""
                      autocomplete="new-password"
                      value={email}
                    />
                    <span class="label">Work Email*</span>
                    <label class="d-none checkoutAccountError logInEmailError" />
                  </div>
                  {emailError && (
                    <span className="error-message-text">{emailError}</span>
                  )}
                </div>
                {email == "" ? (
                  <img src="/businessDashboard/media/images/buttons-add-white.svg" />
                ) : (
                  <img
                    onClick={() => (emailError != "" ? "" : addEmailOneByOne())}
                    className={`${emailError != "" ? "disabled" : "pointer"}`}
                    src="/businessDashboard/media/images/buttons-add-background.svg"
                  />
                )}
              </div>
            </div>
          )}
          {invitationList.length < 1 ? (
            <div className="display-items-on-modal">
              <div className="d-flex gap-18 align-items-center">
                <div className="divider" />
                <p>Or</p>
                <div className="divider" />
              </div>
              <button
                onClick={() => changeInviteBulk(1)}
                className="outline-btn w-100"
              >
                Invite in bulk
              </button>
            </div>
          ) : (
            <div>
              {sendInvite == 0 ? (
                <div className="display-items-on-modal">
                  {displayEmailOneByOne()}
                  <div className="divider" />
                  <div className="d-flex gap-12">
                    <button
                      onClick={backFunction}
                      className="outline-btn w-100"
                    >
                      Back
                    </button>
                    <button
                      className="rounded-btn-default w-100"
                      onClick={() => inviteOneByOne()}
                    >
                      Invite
                    </button>
                  </div>
                </div>
              ) : (
                <div className="display-items-on-modal">
                  {displayHeaderOfModal(2)}
                  {displayAlert && (
                    <div className="information-message">
                     <img className="notDark"
                        src={toAbsoluteUrl("/media/images/alert-circle.svg")}
                        alt="remove-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/alert-circle-dark.svg")}
                        alt="remove-icon"
                      />
                      <p>
                        Our system sent a link via email to the employees who
                        were successfully invited, so they can complete the
                        registration process.
                      </p>
                      <span
                        className="pointer"
                        onClick={() => setDisplayAlert(false)}
                      >
                        Dismiss
                      </span>
                    </div>
                  )}
                  {failedEmail.length > 0 && (
                    <div className="error-message">
                       <img className="notDark"
                        src={toAbsoluteUrl("/media/images/x-octagon.svg")}
                        alt="alert-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/x-octagon-dark.svg")}
                        alt="alert-icon"
                      />
                      <p>
                        One or more email addresses are already enrolled with
                        another company
                      </p>
                    </div>
                  )}
                  {displayEmailOneByOne()}
                  <button
                    className="rounded-btn-default w-100"
                    onClick={() => finishInviteOneByOne()}
                  >
                    Finish
                  </button>
                </div>
              )}
            </div>
          )}
        </Box>
      ) : (
        <Box sx={style}>
          {uploadedFileDone ? (
            <>
              {console.log("setSendInvite", sendInvite)}
              {sendInvite == 0 ? (
                <div className="display-items-on-modal">
                  {displayHeaderOfModal(1)}
                  <div className="remove-file">
                    <div className="d-flex ">
                      <img
                        src={toAbsoluteUrl("/media/images/file-text.svg")}
                        alt="file-icon"
                      />
                      <p>{uploadedFile.name}</p>
                    </div>
                    <span onClick={backFunction}>Remove</span>
                  </div>
                  <div className="display-items-on-modal">
                    {displayEmailOneByOne()}
                    <div className="divider" />
                    <div className="d-flex gap-12">
                      <button
                        onClick={backFunction}
                        className="outline-btn w-100"
                      >
                        Back
                      </button>
                      <button
                        className="rounded-btn-default w-100"
                        onClick={() => checkEmailFormat(invitationList)}
                      >
                        Invite
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="display-items-on-modal">
                    {displayHeaderOfModal(1)}
                    {displayAlert && !showFormatError && sendBulkInvite && (
                    <div className="information-message">
                      <img className="notDark"
                        src={toAbsoluteUrl("/media/images/alert-circle.svg")}
                        alt="remove-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/alert-circle-dark.svg")}
                        alt="remove-icon"
                      />
                      <p>
                        Our system sent a link via email to the employees who
                        were successfully invited, so they can complete the
                        registration process.
                      </p>
                      <span
                        className="pointer"
                        onClick={() => setDisplayAlert(false)}
                      >
                        Dismiss
                      </span>
                    </div>
                  )}
                   {failedEmail.length > 0 && !showFormatError &&sendBulkInvite && (
                    <div className="error-message">
                      <img className="notDark"
                        src={toAbsoluteUrl("/media/images/x-octagon.svg")}
                        alt="alert-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/x-octagon-dark.svg")}
                        alt="alert-icon"
                      />
                      <p>
                        One or more email addresses are already enrolled with
                        another company
                      </p>
                    </div>
                  )}
                  {failedEmail.length > 0 && showFormatError && (
                    <div className="error-message">
                       <img className="notDark"
                        src={toAbsoluteUrl("/media/images/x-octagon.svg")}
                        alt="alert-icon"
                      />
                      <img className="darkMode"
                        src={toAbsoluteUrl("/media/images/x-octagon-dark.svg")}
                        alt="alert-icon"
                      />
                      <p>
                      One or more emails are in the wrong format, please update the wrong emails before inviting
                      </p>
                    </div>
                  )}
                    <div className="display-items-on-modal">
                      {displayEmailOneByOne()}
                      {showFormatError && !sendBulkInvite ? <>
                      <div className="divider" />
                      <div className="d-flex gap-12">
                        <button
                          onClick={backFunction}
                          className="outline-btn w-100"
                        >
                          Back
                        </button>
                        <button
                          className={`rounded-btn-default w-100 ${failedEmail.length<1?'' :'disabled' }`}
                          onClick={() => {if(failedEmail.length<1 ){inviteOneByOne()}}}
                        >
                          Invite
                        </button>
                      </div>
                      </>:
                      <button
                      className="rounded-btn-default w-100"
                      onClick={() => finishInviteOneByOne()}
                    >
                      Finish
                    </button>}
                     
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="display-items-on-modal">
              {displayHeaderOfModal(1)}
              <FileUpload
                setUploadedFileDone={setUploadedFileDone}
                setUploadedFile={setUploadedFile}
                FileUpload={FileUpload}
              />
              <div className="display-items-on-modal">
                <div className="d-flex gap-18 align-items-center">
                  <div className="divider" />
                  <p>Or</p>
                  <div className="divider" />
                </div>
                <button
                  onClick={() => changeInviteBulk(0)}
                  className="outline-btn w-100"
                >
                  Invite one by one
                </button>
              </div>
            </div>
          )}
        </Box>
      )}
    </Modal>
  );
}
